let initialState = {
    korisnici: [],
    cached: false
};

export default function korisniciReducer(state = initialState, action) {
    switch (action.type) {
        case 'GET_USERS': {
            return Object.assign({}, state, {
                korisnici: [...action.users],
                cached: true
            });
        }
        default:
            return state;
    }
}
